import { useCallback } from "react";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanName = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
